const state = {
    answers: {},
}

const getters = {
    answers: state => state.answers
}

const actions = {
    addAnswer({ commit }, answerData) {
        commit('setAnswer', answerData);
    }

}

const mutations = {
    setAnswer(state, answerData) {
        state.answers[answerData.question] = answerData.answer;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}